import { render, staticRenderFns } from "./sealMenu.vue?vue&type=template&id=9d4cb9fc&scoped=true&"
import script from "./sealMenu.vue?vue&type=script&lang=js&"
export * from "./sealMenu.vue?vue&type=script&lang=js&"
import style0 from "./sealMenu.vue?vue&type=style&index=0&id=9d4cb9fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4cb9fc",
  null
  
)

export default component.exports